import type { ReactElement } from "react";
import { Combobox } from "../../../../shared/components/ui/combobox";
import { COUNTRY_OPTIONS } from "../../../../utils/countryMapping";

interface CountrySelectProps {
  readonly value: string | null;
  readonly onChange: (country: string | null) => void;
  readonly disabled?: boolean;
  readonly triggerClassName?: string;
  readonly textClassName?: string;
  readonly placeholder?: string;
  readonly searchInputClassName?: string;
}

/**
 * Combobox component for title country of origin with search
 * Can be used in both inline table editing and full form contexts
 */
export function CountrySelect({
  value,
  onChange,
  disabled,
  triggerClassName = "w-[130px] border-none",
  textClassName = "text-xs truncate",
  placeholder = "Country",
  searchInputClassName = "h-9 pt-4",
}: Readonly<CountrySelectProps>): ReactElement {
  return (
    <Combobox
      value={value}
      onValueChange={onChange}
      options={COUNTRY_OPTIONS}
      placeholder={placeholder}
      searchPlaceholder="Search"
      emptyMessage="No country found."
      disabled={disabled}
      triggerClassName={triggerClassName}
      textClassName={textClassName}
      iconClassName="h-3 w-3"
      dropdownClassName="text-xs h-[200px] rounded-lg mt-1"
      itemClassName="text-xs py-1.5"
      searchInputClassName={searchInputClassName}
    />
  );
}
